exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\npre {\n  white-space: pre-wrap;\n  overflow-x: hidden;\nimg {\n    max-width: 100%;\n}\n}\n", "", {"version":3,"sources":["/Users/junya/sunnyeee/sciseed/sAIFaqAdmin/src/components/Result.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;IACI,gBAAgB;CACnB;CACA","file":"Result.vue","sourcesContent":["\npre {\n  white-space: pre-wrap;\n  overflow-x: hidden;\nimg {\n    max-width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-097db513","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Result.vue
// module id = +SRj
// module chunks = 0